export const PRIMARY_DARK_GREEN = "#00A195";
export const SECONDARY_DARK_GREEN = "#007A72";

// #0A9A90

export const PRIMARY_LIGHT_GREEN = "#E4EFED";
export const SECONDARY_LIGHT_GREEN = "#E5FAF9";

export const PRIMARY_RED = "#D91C0B";
export const SECONDARY_RED = "#F58B8B";

export const PRIMARY_LIGHT_RED = "#FDF4F3";

export const PRIMARY_BLUE = "#2586EF";

export const PRIMARY_DARK_BLUE = "#195da6";

export const PRIMARY_GRAY = "#585757";

export const PRIMARY_LIGHT_GRAY = "#F2F2F2";
